// React Imports
import type { SVGAttributes } from 'react';
import React from 'react';

export const AppGold = (_props: SVGAttributes<SVGElement>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.43272 4H6.00528C4.8978 4 4 4.90859 4 6.02938V8.48599C4 9.60678 4.8978 10.5154 6.00528 10.5154H8.43272C9.5402 10.5154 10.438 9.60678 10.438 8.48599V6.02938C10.438 4.90859 9.5402 4 8.43272 4Z"
        stroke="url(#paint0_linear_4218_106781)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9952 4H15.5678C14.4603 4 13.5625 4.90859 13.5625 6.02938V8.48599C13.5625 9.60678 14.4603 10.5154 15.5678 10.5154H17.9952C19.1027 10.5154 20.0005 9.60678 20.0005 8.48599V6.02938C20.0005 4.90859 19.1027 4 17.9952 4Z"
        stroke="url(#paint1_linear_4218_106781)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.43272 13.4844H6.00528C4.8978 13.4844 4 14.3929 4 15.5137V17.9703C4 19.0911 4.8978 19.9997 6.00528 19.9997H8.43272C9.5402 19.9997 10.438 19.0911 10.438 17.9703V15.5137C10.438 14.3929 9.5402 13.4844 8.43272 13.4844Z"
        stroke="url(#paint2_linear_4218_106781)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9952 13.4844H15.5678C14.4603 13.4844 13.5625 14.3929 13.5625 15.5137V17.9703C13.5625 19.0911 14.4603 19.9997 15.5678 19.9997H17.9952C19.1027 19.9997 20.0005 19.0911 20.0005 17.9703V15.5137C20.0005 14.3929 19.1027 13.4844 17.9952 13.4844Z"
        stroke="url(#paint3_linear_4218_106781)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4218_106781"
          x1="7.21899"
          y1="4"
          x2="7.21899"
          y2="10.5154"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBE66" />
          <stop offset="0.34" stopColor="#EDB05D" />
          <stop offset="1" stopColor="#CA7701" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4218_106781"
          x1="16.7815"
          y1="4"
          x2="16.7815"
          y2="10.5154"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBE66" />
          <stop offset="0.34" stopColor="#EDB05D" />
          <stop offset="1" stopColor="#CA7701" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4218_106781"
          x1="7.21899"
          y1="13.4844"
          x2="7.21899"
          y2="19.9997"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBE66" />
          <stop offset="0.34" stopColor="#EDB05D" />
          <stop offset="1" stopColor="#CA7701" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_4218_106781"
          x1="16.7815"
          y1="13.4844"
          x2="16.7815"
          y2="19.9997"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBE66" />
          <stop offset="0.34" stopColor="#EDB05D" />
          <stop offset="1" stopColor="#CA7701" />
        </linearGradient>
      </defs>
    </svg>
  );
};
